import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as retrieveStrategicAxes from "./retrieveStrategicAxes";

import * as createStrategicAxis from "./createStrategicAxis";

import * as removeStrategicAxis from "./removeStrategicAxis";

import * as editStrategicAxis from "./editStrategicAxis";

import * as createProjectStrategicAxis from "./createProjectStrategicAxis";

import * as retrieveProjectStrategicAxes from "./retrieveProjectStrategicAxes";

import * as editProjectStrategicAxis from "./editProjectStrategicAxis";

const initialState: State = {
  retrieveStrategicAxes: retrieveStrategicAxes.initialState,
  createStrategicAxis: createStrategicAxis.initialState,
  removeStrategicAxis: removeStrategicAxis.initialState,
  editStrategicAxis: editStrategicAxis.initialState,
  createProjectStrategicAxis: createProjectStrategicAxis.initialState,
  retrieveProjectStrategicAxes: retrieveProjectStrategicAxes.initialState,
  editProjectStrategicAxis: editProjectStrategicAxis.initialState,
};

const reduceState = combineStateReducer(initialState, {
  retrieveStrategicAxes: retrieveStrategicAxes.reduceState,
  createStrategicAxis: createStrategicAxis.reduceState,
  removeStrategicAxis: removeStrategicAxis.reduceState,
  editStrategicAxis: editStrategicAxis.reduceState,
  createProjectStrategicAxis: createProjectStrategicAxis.reduceState,
  retrieveProjectStrategicAxes: retrieveProjectStrategicAxes.reduceState,
  editProjectStrategicAxis: editProjectStrategicAxis.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...retrieveStrategicAxes.createSelector(
      () => getState().retrieveStrategicAxes,
    ),
    ...createStrategicAxis.createSelector(() => getState().createStrategicAxis),
    ...removeStrategicAxis.createSelector(() => getState().removeStrategicAxis),
    ...editStrategicAxis.createSelector(() => getState().editStrategicAxis),
    ...createProjectStrategicAxis.createSelector(
      () => getState().createProjectStrategicAxis,
    ),
    ...retrieveProjectStrategicAxes.createSelector(
      () => getState().retrieveProjectStrategicAxes,
    ),
    ...editProjectStrategicAxis.createSelector(
      () => getState().editProjectStrategicAxis,
    ),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
